import React from "react";
import "../assets/css/tech.css";
import offerleft from "../assets/images/offer-bg-shape-left.png";
import offershadow from "../assets/images/offer-shadow-shape.png";
import offerright from "../assets/images/offer-bg-shape-right.png";
import secctiontitle from "../assets/images/section-title.png";
import offertop from "../assets/images/offter-item-shape-top.png";
import offerbuttom from "../assets/images/offter-item-shape-bottom.png";
import { FaReact } from "react-icons/fa";
import { GrAndroid } from "react-icons/gr";

const Technology = () => {
  return (
    <section className="offer-area secondary-bg pt-120 pb-200">
      <div
        className="offer__shadow wow fadeIn"
        data-wow-delay="200ms"
        data-wow-duration="1500ms"
      >
        <img src={offershadow} alt="shadow" />
      </div>
      <div className="offer__shape-left">
        <img
          className="wow fadeInUpBig"
          data-wow-delay="400ms"
          data-wow-duration="1500ms"
          src={offerleft}
          alt="shape"
        />
      </div>
      <div className="offer__shape-right">
        <img
          className="wow fadeInDownBig"
          data-wow-delay="400ms"
          data-wow-duration="1500ms"
          src={offerright}
          alt="shape"
        />
      </div>
      <div className="container">
        <div className="d-flex gap-4 flex-wrap align-items-center justify-content-between mb-95">
          <div className="section-header">
            <h5
              className="wow fadeInLeft"
              data-wow-delay="00ms"
              data-wow-duration="1500ms"
            >
              <img className="me-1" src={secctiontitle} alt="icon" />
              Our offering
            </h5>
            <h2
              className="text-white wow fadeInLeft"
              data-wow-delay="200ms"
              data-wow-duration="1500ms"
            >
              Enhance and Pioneer Using <br /> Technology Trends
            </h2>
          </div>
          <a
            href="pricing.html"
            className="btn-one wow fadeInUp"
            data-wow-delay="200ms"
            data-wow-duration="1500ms"
          >
            Explore More <i className="fa-regular fa-arrow-right-long" />
          </a>
        </div>
        <div className="row g-4">
          <div
            className="col-lg-2 col-md-4 col-sm-6 wow bounceInUp"
            data-wow-delay="00ms"
            data-wow-duration="1500ms"
          >
            <div className="offer__item">
              <div className="shape-top">
                <img src={offertop} alt="shape" />
              </div>
              <div className="shape-bottom">
                <img src={offerbuttom} alt="shape" />
              </div>
              <div className="offer__icon">
                {/* <svg
                  width={36}
                  height={36}
                  viewBox="0 0 36 36"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M18 0C10.3961 0 0 5.74724 0 18C0 29.9409 9.99921 36 18 36C31.7268 36 36 23.974 36 18C36 9.18425 29.2535 0 18 0ZM13.826 1.6937C11.948 3.29528 10.389 5.94567 9.38268 9.23386C8.07874 8.46142 6.8811 7.50472 5.81811 6.39213C8.01496 4.08898 10.7929 2.47323 13.826 1.6937ZM5.04567 7.25669C6.23622 8.49685 7.58976 9.55276 9.06378 10.389C8.51102 12.5362 8.18504 14.9173 8.14252 17.4189H1.17638C1.30394 13.6843 2.66457 10.1197 5.04567 7.25669ZM5.04567 28.7433C2.65748 25.8803 1.30394 22.3158 1.17638 18.5811H8.14252C8.18504 21.0898 8.51102 23.4638 9.06378 25.611C7.59685 26.4543 6.24331 27.5032 5.04567 28.7433ZM5.81811 29.615C6.8811 28.5024 8.07874 27.5457 9.38268 26.7732C10.389 30.0543 11.948 32.7118 13.826 34.3134C10.7929 33.5268 8.01496 31.911 5.81811 29.615ZM17.4189 34.7953C14.4 34.4126 11.7992 31.0394 10.3961 26.2063C12.5646 25.1079 14.9598 24.4913 17.4189 24.3992V34.7953ZM17.4189 23.2441C14.8535 23.3291 12.3591 23.9598 10.0984 25.0654C9.62362 23.0811 9.34016 20.8913 9.29764 18.5811H17.4189V23.2441ZM17.4189 17.4189H9.29764C9.34016 15.1087 9.62362 12.9189 10.0984 10.9346C12.3661 12.0402 14.8606 12.6709 17.4189 12.7559V17.4189ZM17.4189 11.6008C14.9528 11.5157 12.5646 10.8921 10.3961 9.7937C11.7992 4.95354 14.4 1.5874 17.4189 1.20472V11.6008ZM30.9543 7.25669C33.3354 10.1197 34.6961 13.6843 34.8236 17.4189H27.8646C27.8221 14.9102 27.4961 12.5362 26.9433 10.389C28.4102 9.54567 29.7638 8.49685 30.9543 7.25669ZM30.1819 6.38504C29.1189 7.49764 27.9213 8.45433 26.6173 9.22677C25.611 5.94567 24.052 3.29528 22.174 1.68661C25.2071 2.47323 27.985 4.08898 30.1819 6.38504ZM18.5811 1.20472C21.6 1.5874 24.2008 4.96063 25.6039 9.7937C23.4354 10.8921 21.0472 11.5087 18.5811 11.6008V1.20472ZM18.5811 12.7559C21.1465 12.6709 23.6409 12.0402 25.9016 10.9346C26.3764 12.9189 26.6598 15.1087 26.7024 17.4189H18.5811V12.7559ZM18.5811 18.5811H26.7024C26.6598 20.8913 26.3764 23.0811 25.9016 25.0654C23.6195 23.9424 21.1233 23.3213 18.5811 23.2441V18.5811ZM18.5811 34.7953V24.3992C21.0472 24.4843 23.4354 25.1079 25.6039 26.2063C24.2008 31.0465 21.6 34.4126 18.5811 34.7953ZM22.174 34.3063C24.052 32.7047 25.611 30.0543 26.6173 26.7661C27.9213 27.5386 29.1189 28.4953 30.1819 29.6079C27.985 31.911 25.2071 33.5268 22.174 34.3063ZM30.9543 28.7433C29.7638 27.5032 28.4102 26.4543 26.9433 25.611C27.4961 23.4638 27.8221 21.0827 27.8646 18.5811H34.8236C34.6961 22.3158 33.3354 25.8803 30.9543 28.7433Z"
                    fill="#3C72FC"
                  />
                </svg> */}
                <svg
                  viewBox="0 0 24 24"
                  fill="currentColor"
                  height="2em"
                  width="2em"

                >
                  <path d="M11.964 0L.672 3.974l1.784 14.794L11.976 24l9.568-5.303 1.784-14.794zm-.027 1.258l10.265 3.5-1.663 13.232-8.602 4.76-8.469-4.697L1.939 4.822zm0 .78L4.957 17.57l2.604-.048 1.4-3.501h6.257l1.532 3.55 2.492.046zm.02 4.98l2.355 4.93H9.878z" />
                </svg>
              </div>
              <h4 className="text-white mt-20">Angular</h4>
            </div>
          </div>
          <div
            className="col-lg-2 col-md-4 col-sm-6 wow bounceInUp"
            data-wow-delay="100ms"
            data-wow-duration="1500ms"
          >
            <div className="offer__item">
              <div className="shape-top">
                <img src={offertop} alt="shape" />
              </div>
              <div className="shape-bottom">
                <img src={offerbuttom} alt="shape" />
              </div>
              <div className="offer__icon">

                <svg

                  width={36}
                  height={36}
                  viewBox="0 0 36 36"
                  fill="none"

                >
                  <path
                    fill="currentColor"
                    d="M8.579 10.956a1.95 1.95 0 01.125-.053c-.041.016-.083.035-.125.053zM2.496 22.174h1.59c.005 0 .011.006.017.005 2.378-.122 3.48-1.352 4.034-3.124.431-1.375.784-2.532 1.094-3.504v.001l.011-.035a25.146 25.146 0 012.215-2.687h.016c1.065 3.257 1.476 9.068 4.591 9.068.126 0 .257.003.384-.01-.127.013-.25.03-.376.03h2.474a2.463 2.463 0 01-.796-.144 2.466 2.466 0 00.796.125c.459 0 .842-.035 1.176-.144-.334.109-.717.162-1.176.162H21.03l.001-.005.913-.009c-.117 0-.226-.021-.331-.056l.004-.005c.103.031.21.037.325.037 2.403 0 4.826-4.315 8.835-11.483h-1.574l.001.064h-.293c-1.478 2.624-2.511 4.866-3.387 6.658.877-1.794 1.909-4.034 3.386-6.658h-2.405c-.08 0-.157-.011-.234-.006l-.001-.005c-2.321.14-3.407 1.318-3.953 3.067-.956 3.056-1.535 5.034-2.092 6.297 0 0 0-.001 0 0 0 .003-.002.003-.002.004v-.003a10.302 10.302 0 01-1.191.991c.114.137.231.265.354.382.186.181.385.333.602.45h-.001a2.738 2.738 0 01-.603-.45 4.648 4.648 0 01-.354-.382 8.53 8.53 0 00.408-.307c-.749-1.659-1.184-4.478-1.991-6.673.807 2.194 1.243 5.014 1.991 6.673.26-.207.52-.435.781-.685-1.082-3.242-1.47-9.136-4.606-9.136a3.759 3.759 0 000-.001l-1.233-.017c.196 0 .381.055.557.055-.176 0-.361-.055-.556-.055-.017 0-.034-.004-.051-.003.017 0 .034-.006.051-.006h-4.96c-.028 0-.056-.004-.085-.004-2.706 0-6.435 5.059-8.115 11.524h1.273zm23.665-11.499c-.807.254-1.401.694-1.842 1.277.441-.583 1.034-1.023 1.842-1.277zm-3.792 10.866l-.023.012-.034.017-.002.001.059-.029zm-.329.146c.005-.004.01-.004.016-.006l-.015.006-.033.012.032-.012zm-.039.016H22h.001zm-.25.084a1.567 1.567 0 01.081-.025l.03-.011c.011-.004.022-.006.031-.01l.026-.01.064-.022a.011.011 0 00.008-.003l-.007.003-.063.022-.026.009c-.009.004-.02.007-.031.01-.009.004-.02.006-.031.011l-.027.009a.85.85 0 00-.054.016l-.004.001.003-.001zM8.704 10.91v-.008l.007.008c-.053 0-.105.037-.157.059l.025-.012a3.499 3.499 0 00-.126.057c-.022.011-.045.021-.067.033zm.128-.064zm.359-.108c-.007.004-.012.019-.018.019l-.132.035c-.005 0-.009.004-.015.005l-.037.011c.013-.004.025-.011.037-.013.006 0 .011-.005.015-.005l.132-.035c.006 0 .011-.018.018-.018.012-.004.024-.02.037-.021-.013.001-.025.021-.037.023zm.058-.006a.087.087 0 01-.019.01c.006-.004.012-.011.019-.013.013-.004.025-.014.039-.014-.014 0-.026.015-.039.017zm.483-.016c-.024-.004-.047-.002-.07-.002H9.66c.023 0 .046-.003.07 0l.008-.001c-.002.001-.003.003-.006.003zm.062-.031c-.058 0-.115.012-.174.016.008 0 .016.01.024.012-.015-.002-.03-.011-.045-.012.007-.001.014-.005.021-.005l-.008-.002a.04.04 0 00-.012-.006v.005c-.064.004-.06.005-.088.008l-.004-.005c-.008 0-.014.004-.021.004-.011.004-.024.004-.036.005-.007 0-.014 0-.021.004-.013.004-.025.006-.037.008l-.003.001h.003c.013 0 .024-.006.037-.009.007 0 .014-.005.021-.005.012 0 .024-.004.036-.006.006 0 .012 0 .02-.004l.072-.007.014.001c.068-.006.134-.008.201-.008zm.161.07a1.587 1.587 0 00-.137-.029l-.012-.003a2.086 2.086 0 01.148.032l.004.001h-.002zm.979.782l-.001.001a2.294 2.294 0 00-.468-.584l.007.004c.169.147.321.344.461.58zm.22.424zm2.511-1.217a3.843 3.843 0 01-.001.001zm-1.761 1.702l-.004-.008.004.008zm2.305-1.499zm.731-.204zm2.164 11.015a5.454 5.454 0 010 0zm3.032-.197l-.021.011.022-.012zm.626.323l.126.011a4.557 4.557 0 01-.126-.011zm-.02-.849l.001-.005.001-.001c.157.267.331.487.527.639a2.133 2.133 0 01-.528-.633zm.446.86c-.008.004-.015.004-.023.004h-.002c.008 0 .016 0 .023-.004.015 0 .03 0 .046-.004h.002c-.016.004-.031.004-.046.004zm.189-.021c-.017.003-.035.004-.053.008-.005 0-.01.004-.015.004h-.004c-.016.002-.033.005-.049.005h-.002c.016 0 .033-.004.049-.005h.004c.005 0 .01-.004.015-.004.018-.004.036-.006.053-.008h.004-.002z"
                  />
                </svg>
              </div>
              <h4 className="text-white mt-20"> .NET</h4>
            </div>
          </div>
          <div
            className="col-lg-2 col-md-4 col-sm-6 wow bounceInUp"
            data-wow-delay="200ms"
            data-wow-duration="1500ms"
          >
            <div className="offer__item">
              <div className="shape-top">
                <img src={offertop} alt="shape" />
              </div>
              <div className="shape-bottom">
                <img src={offerbuttom} alt="shape" />
              </div>
              <div className="offer__icon">

                <svg
                  viewBox="0 0 512 512"
                  fill="currentColor"
                  width={36}
                  height={36}


                >
                  <path d="M504.4 115.83a5.72 5.72 0 00-.28-.68 8.52 8.52 0 00-.53-1.25 6 6 0 00-.54-.71 9.36 9.36 0 00-.72-.94c-.23-.22-.52-.4-.77-.6a8.84 8.84 0 00-.9-.68L404.4 55.55a8 8 0 00-8 0L300.12 111a8.07 8.07 0 00-.88.69 7.68 7.68 0 00-.78.6 8.23 8.23 0 00-.72.93c-.17.24-.39.45-.54.71a9.7 9.7 0 00-.52 1.25c-.08.23-.21.44-.28.68a8.08 8.08 0 00-.28 2.08v105.24l-80.22 46.19V63.44a7.8 7.8 0 00-.28-2.09c-.06-.24-.2-.45-.28-.68a8.35 8.35 0 00-.52-1.24c-.14-.26-.37-.47-.54-.72a9.36 9.36 0 00-.72-.94 9.46 9.46 0 00-.78-.6 9.8 9.8 0 00-.88-.68L115.61 1.07a8 8 0 00-8 0L11.34 56.49a6.52 6.52 0 00-.88.69 7.81 7.81 0 00-.79.6 8.15 8.15 0 00-.71.93c-.18.25-.4.46-.55.72a7.88 7.88 0 00-.51 1.24 6.46 6.46 0 00-.29.67 8.18 8.18 0 00-.28 2.1v329.7a8 8 0 004 6.95l192.5 110.84a8.83 8.83 0 001.33.54c.21.08.41.2.63.26a7.92 7.92 0 004.1 0c.2-.05.37-.16.55-.22a8.6 8.6 0 001.4-.58L404.4 400.09a8 8 0 004-6.95V287.88l92.24-53.11a8 8 0 004-7V117.92a8.63 8.63 0 00-.24-2.09zM111.6 17.28l80.19 46.15-80.2 46.18-80.18-46.17zm88.25 60V278.6l-46.53 26.79-33.69 19.4V123.5l46.53-26.79zm0 412.78L23.37 388.5V77.32L57.06 96.7l46.52 26.8v215.18a6.94 6.94 0 00.12.9 8 8 0 00.16 1.18 5.92 5.92 0 00.38.9 6.38 6.38 0 00.42 1 8.54 8.54 0 00.6.78 7.62 7.62 0 00.66.84c.23.22.52.38.77.58a8.93 8.93 0 00.86.66l92.19 52.18zm8-106.17l-80.06-45.32 84.09-48.41 92.26-53.11 80.13 46.13-58.8 33.56zm184.52 4.57L215.88 490.11V397.8l130.72-74.6 45.77-26.15zm0-119.13L358.68 250l-46.53-26.79v-91.42l33.69 19.4L392.37 178zm8-105.28l-80.2-46.17 80.2-46.16 80.18 46.15zm8 105.28V178L455 151.19l33.68-19.4v91.39z" />
                </svg>
              </div>
              <h4 className="text-white mt-20">Laravel</h4>
            </div>
          </div>
          <div
            className="col-lg-2 col-md-4 col-sm-6 wow bounceInUp"
            data-wow-delay="300ms"
            data-wow-duration="1500ms"
          >
            <div className="offer__item">
              <div className="shape-top">
                <img src={offertop} alt="shape" />
              </div>
              <div className="shape-bottom">
                <img src={offerbuttom} alt="shape" />
              </div>
              <div className="offer__icon">
                <GrAndroid size={30} />
              </div>
              <h4 className="text-white mt-20">Anroid</h4>
            </div>
          </div>
          <div
            className="col-lg-2 col-md-4 col-sm-6 wow bounceInUp"
            data-wow-delay="400ms"
            data-wow-duration="1500ms"
          >
            <div className="offer__item">
              <div className="shape-top">
                <img src={offertop} alt="shape" />
              </div>
              <div className="shape-bottom">
                <img src={offerbuttom} alt="shape" />
              </div>
              <div className="offer__icon">
                <svg
                  viewBox="0 0 24 24"
                  fill="currentColor"
                  height="2em"
                  width="2em"

                >
                  <path d="M12 1.85c-.27 0-.55.07-.78.2l-7.44 4.3c-.48.28-.78.8-.78 1.36v8.58c0 .56.3 1.08.78 1.36l1.95 1.12c.95.46 1.27.47 1.71.47 1.4 0 2.21-.85 2.21-2.33V8.44c0-.12-.1-.22-.22-.22H8.5c-.13 0-.23.1-.23.22v8.47c0 .66-.68 1.31-1.77.76L4.45 16.5a.26.26 0 01-.11-.21V7.71c0-.09.04-.17.11-.21l7.44-4.29c.06-.04.16-.04.22 0l7.44 4.29c.07.04.11.12.11.21v8.58c0 .08-.04.16-.11.21l-7.44 4.29c-.06.04-.16.04-.23 0L10 19.65c-.08-.03-.16-.04-.21-.01-.53.3-.63.36-1.12.51-.12.04-.31.11.07.32l2.48 1.47c.24.14.5.21.78.21s.54-.07.78-.21l7.44-4.29c.48-.28.78-.8.78-1.36V7.71c0-.56-.3-1.08-.78-1.36l-7.44-4.3c-.23-.13-.5-.2-.78-.2M14 8c-2.12 0-3.39.89-3.39 2.39 0 1.61 1.26 2.08 3.3 2.28 2.43.24 2.62.6 2.62 1.08 0 .83-.67 1.18-2.23 1.18-1.98 0-2.4-.49-2.55-1.47a.226.226 0 00-.22-.18h-.96c-.12 0-.21.09-.21.22 0 1.24.68 2.74 3.94 2.74 2.35 0 3.7-.93 3.7-2.55 0-1.61-1.08-2.03-3.37-2.34-2.31-.3-2.54-.46-2.54-1 0-.45.2-1.05 1.91-1.05 1.5 0 2.09.33 2.32 1.36.02.1.11.17.21.17h.97c.05 0 .11-.02.15-.07.04-.04.07-.1.05-.16C17.56 8.82 16.38 8 14 8z" />
                </svg>
              </div>
              <h4 className="text-white mt-20">Node.js</h4>
            </div>
          </div>
          <div
            className="col-lg-2 col-md-4 col-sm-6 wow bounceInUp"
            data-wow-delay="500ms"
            data-wow-duration="1500ms"
          >
            <div className="offer__item">
              <div className="shape-top">
                <img src={offertop} alt="shape" />
              </div>
              <div className="shape-bottom">
                <img src={offerbuttom} alt="shape" />
              </div>
              <div className="offer__icon">
                <FaReact size={30} />
              </div>
              <h4 className="text-white mt-20">React</h4>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Technology;
